import {memo, useEffect, useRef, useState} from 'react';

const NotamContentComponent = ({
  showMore,
  item,
  setShowMore
}: {
  showMore: boolean;
  item: any;
  setShowMore: (showMore: boolean) => void;
}) => {
  const [isMoreThan4Lines, setIsMoreThan4Lines] = useState(false);
  const paragraphRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    if (paragraphRef.current) {
      const lineHeight = 24; // px
      const maxVisibleHeight = lineHeight * 4;
      setIsMoreThan4Lines(paragraphRef.current.scrollHeight > maxVisibleHeight);
    }
  }, [item?.line, item?.content]);

  return (
    <div className="w-full mb-[8px] bg-[#000F0A] rounded-[12px] p-[12px]">
      <p
        ref={paragraphRef}
        style={{
          fontFamily: 'Geist',
          fontSize: 16,
          lineHeight: '24px',
          color: '#FAFAF9',
          letterSpacing: '2%',
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitLineClamp: showMore ? 'unset' : 4,
          WebkitBoxOrient: 'vertical'
        }}
      >
        {item?.line && item?.line !== '' ? item.line : item.content}
      </p>

      {item?.raw_effectivity && item?.raw_effectivity !== '' && (
        <p className="text-[16px] leading-[24px] text-[#F1F1F1] mt-[8px]">
          Effectivity: {item.raw_effectivity}
        </p>
      )}

      {isMoreThan4Lines && (
        <button onClick={() => setShowMore(!showMore)} className="mt-[6px]">
          <span
            className="text-[14px] leading-[14px] tracking-[-0.28px] text-[#38BDF8] font-medium"
            style={{fontFamily: 'Geist'}}
          >
            {showMore ? 'See less' : 'See more'}
          </span>
        </button>
      )}
    </div>
  );
};

const NotamContent = memo(NotamContentComponent);
export default NotamContent;
